// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2164":"c2c2fb66","3775":"c2c2fb66","5688":"32cecc8a","5765":"1836703c"}[chunkId] + ".chunk.css";
};